(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryDeleteController',EventFormCategoryDeleteController);

    EventFormCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventFormCategory'];

    function EventFormCategoryDeleteController($uibModalInstance, entity, EventFormCategory) {
        var vm = this;
        vm.EventFormCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventFormCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
